import { useData } from '../lib/data.jsx';
import { B } from '../lib/util.js';
import { todayISO, addD } from '../lib/util.js';

// รายรับ — แยกรายได้จริงออกจากเงินประกัน (หนี้สิน) เสมอ
export default function Dash() {
  const { dash, units, bySku, isFreeRange } = useData();

  const busy = units.filter(u => !isFreeRange(u.id, todayISO(), addD(todayISO(), 2))).length;
  const util = units.length ? Math.round(busy / units.length * 100) : 0;

  const rev = dash ? Number(dash.rent_revenue) + Number(dash.late_revenue) + Number(dash.cleaning_revenue) : 0;
  const rows = dash ? [
    ['ค่าเช่าอุปกรณ์', Number(dash.rent_revenue)],
    ['ค่าปรับคืนช้า', Number(dash.late_revenue)],
    ['ค่าทำความสะอาด', Number(dash.cleaning_revenue)],
    ['ส่วนต่างสินค้าสภาพดี', Number(dash.resale_margin)],
  ] : [];
  const max = Math.max(1, ...rows.map(r => r[1]));

  const top = [...units].sort((a, b) => b.trips - a.trips).slice(0, 6);

  return (<>
    <div className="pagehead">
      <div className="eyebrow">รายรับ · REVENUE</div>
      <h1 className="bighead">รายรับและภาระผูกพัน</h1>
      <p className="lede">แยกรายได้จริงออกจากเงินประกันที่ต้องคืนลูกค้า เพื่อไม่ให้ตัวเลขบวมเกินจริง</p>
    </div>
    <div className="statbox" style={{ marginBottom: 8 }}>
      <div className="stat"><div className="k">รายได้เดือนนี้ · REVENUE</div><div className="v">{dash ? B(rev) : '—'} <small>฿</small></div></div>
      <div className="stat"><div className="k">VAT ที่ต้องนำส่ง · OUTPUT VAT</div><div className="v">{dash ? B(dash.output_vat) : '—'} <small>฿</small></div></div>
      <div className="stat ok"><div className="k">ถูกหัก ณ ที่จ่าย · WHT</div><div className="v">{dash ? B(dash.wht_withheld) : '—'} <small>฿</small></div></div>
      <div className="stat"><div className="k">อัตราใช้งานอุปกรณ์ · UTIL</div><div className="v">{util}<small>%</small></div></div>
    </div>
    <div className="note show" style={{ margin: '0 0 22px' }}>
      เงินประกันที่ถือไว้ <b>{dash ? B(dash.deposits_held) : '—'} ฿</b> ไม่นับเป็นรายได้ เพราะเป็นหนี้สินที่ต้องคืนลูกค้า
      · เครดิตค้างใช้ <b>{dash ? B(dash.credits_outstanding) : '—'} ฿</b> เป็นภาระส่วนลดในอนาคต
    </div>

    <div className="grid g2">
      <div className="card">
        <h2>รายได้แยกตามประเภท</h2>
        <div className="hint">เฉพาะรายการที่เป็นรายได้จริงและมี VAT (ค่าเสียหายเดือนนี้ {dash ? B(dash.damage_collected) : '—'} ฿ — รอนักบัญชีชี้ขาดเรื่อง VAT จึงแสดงแยก)</div>
        <div style={{ marginTop: 12 }}>
          {rows.map(([n, v]) => (
            <div className="revrow" key={n}>
              <span>{n}</span>
              <span className="revbar"><i style={{ width: Math.round(v / max * 100) + '%' }} /></span>
              <span className="amt">{B(v)}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="card">
        <h2>อุปกรณ์ทำเงินสูงสุด</h2>
        <div className="hint">นับจากรอบการใช้งานสะสม</div>
        <table style={{ marginTop: 8 }}>
          <thead><tr><th>อุปกรณ์</th><th className="r">รอบ</th><th className="r">รายได้สะสม (ประมาณ)</th></tr></thead>
          <tbody>
            {top.map(u => (
              <tr key={u.id}>
                <td>{u.name} · {u.unit_code}</td>
                <td className="r mono">{u.trips}</td>
                <td className="r mono" style={{ fontWeight: 600 }}>{B(u.trips * Number(u.trip_rate))}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </>);
}
